﻿/// <reference path="./libs/phaser.d.ts" />

export namespace BattleCity
{
    export class MainMenu extends Phaser.State
    {
        background: Phaser.Sprite;
        pressEnter: Phaser.Sprite;
        toStart: Phaser.Sprite;

        enterKey: Phaser.Key;

        create()
        {
            this.background = this.add.sprite(0, 0, "titlepage");
            this.pressEnter = this.add.sprite(this.world.width / 2, this.world.height / 2 + 100, "battleCityScene", "press_enter.png");
            this.pressEnter.anchor.setTo(0.5);
            this.toStart = this.add.sprite(this.world.width / 2, this.world.height / 2 + 120, "battleCityScene", "to_start.png");
            this.toStart.anchor.setTo(0.5);

            // Start Game
            this.enterKey = this.input.keyboard.addKey(Phaser.Keyboard.ENTER);
            this.enterKey.onDown.addOnce(this.start, this);
        }

        start()
        {
            this.state.start("Stage");
        }
    }
}